module.exports = __webpack_public_path__ + "img/bg_main_sec01_m.32aef0eb.jpg";